'use strict';

bbw.service.RegisterUserSvc = Class({

    $inject: ['rpcClient', 'bbw.StatsSvc', '$q', '$timeout'],

    rpcClient: undefined,
    bbwStatsSvc: undefined,
    $q: undefined,

    construct: function(rpcClient, bbwStatsSvc, $q) {
        this.rpcClient = rpcClient;
        this.bbwStatsSvc = bbwStatsSvc;
        this.$q = $q;
    },

    registerUser: function(registerUserDto) {
        return this.rpcClient.post('user/signup', registerUserDto).execute()
            .then(function(response) {
                this.bbwStatsSvc.goal('signup');
                return response;
            }.bind(this))
            .catch(function(response) {
                if (angular.isObject(response) && response.error) {
                    switch (response.error) {
                        case 'email_exists':
                        case 'user_is_banned':
                            return this.$q.reject(response.error);
                    }
                }
                return this.$q.reject(response);
            }.bind(this));
    }

});
